export default "__VITE_ASSET__CtnYRQfE__"